import { parseQueryStrings } from '@crehana/utils';

import SignIn from './SignIn';
import SignUp from './SignUp';
import type { AuthInnerFormProps, FormView, OnChangeForm } from './types';

export type ExtraState = {
  currentForm?: FormView;
};

export type AuthFormProps = {
  referFriend?: {
    firstName: string;
    lastName: string;
    originalId: number;
    profilePictureUrl: string;
    username: string;
  };
  onChangeForm: OnChangeForm;
  currentForm: FormView;
  isDark?: boolean;
  onSuccess?: AuthInnerFormProps['onCustomSuccess'];
};

const AuthForm: React.FC<React.PropsWithChildren<AuthFormProps>> = ({
  currentForm,
  // authForm,
  referFriend,
  onChangeForm,
  isDark,
  onSuccess,
}) => {
  const { email_user: emailParam } =
    parseQueryStrings(
      typeof window !== 'undefined' ? window.location.search : '',
    ) || {};
  const emailDefault = typeof emailParam === 'string' ? emailParam : undefined;
  // const { me } = useMe();
  /**
   * TODO: Organization and referAFriendId comes from initialState
   */

  const formView =
    currentForm === 'register' ? (
      <SignUp
        referFriendId={referFriend?.originalId}
        emailDefault={emailDefault}
        onChangeForm={onChangeForm}
        isDark={isDark}
        onCustomSuccess={onSuccess}
      />
    ) : (
      <SignIn
        emailDefault={emailDefault}
        isDark={isDark}
        onChangeForm={onChangeForm}
        onCustomSuccess={onSuccess}
      />
    );

  return formView;
};

export default AuthForm;
